import { render } from "./InfoPanel.vue?vue&type=template&id=17087653&scoped=true&ts=true"
import script from "./InfoPanel.vue?vue&type=script&lang=ts"
export * from "./InfoPanel.vue?vue&type=script&lang=ts"

import "./InfoPanel.vue?vue&type=style&index=0&id=17087653&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17087653"]])

export default __exports__